export type ErrorType = string | null;

// Determina un valor inicial seguro según T
export function getInitialData<T>(): T {
  const t: any = null as unknown as T;
  if (Array.isArray(t)) return [] as any;
  if (typeof t === "object" && t !== null) return {} as any;
  return "" as any;
}

export interface ApiResponse<T> {
  data?: T;
  code?: number;
}

export const HTTP_SUCCESS_MIN = 200;
export const HTTP_SUCCESS_MAX = 299;
export const ERROR_FETCH_DATA = "errorFetchingData";